import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useConsent } from '../contexts/ConsentContext';
import Logo from './Logo';

export default function Footer() {
  const { t, language } = useLanguage();
  const { ouvrirReglages } = useConsent();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-text_primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              {/* Pied de page sombre : le logo passe en blanc, le contour
                  brun d'origine ne s'y détacherait pas. */}
              <Logo className="h-10 w-auto" couleur="#ffffff" />
              <h3 className="text-xl font-bold font-heading">AfriOne BD</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              {t('heroSubtitle')}
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 uppercase tracking-widest text-xs text-white/50">{t('quickLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-home">{t('home')}</Link></li>
              <li><Link to="/products" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-products">{t('products')}</Link></li>
              <li><Link to="/delivery" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-delivery">{t('delivery')}</Link></li>
              <li><Link to="/about" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-about">{t('about')}</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-primary transition-colors" data-testid="footer-contact">{t('contact')}</Link></li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4 uppercase tracking-widest text-xs text-white/50">{t('contactInfo')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-white/70 text-sm">Rue St Nicolas 227, Belgique</span>
              </li>
              <li>
                <a href="tel:0465710117" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors" data-testid="footer-phone-1">
                  <Phone className="w-5 h-5 text-primary" />
                  <span className="text-sm">0465 71 01 17</span>
                </a>
              </li>
              <li>
                <a href="tel:0465288417" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors" data-testid="footer-phone-2">
                  <Phone className="w-5 h-5 text-primary" />
                  <span className="text-sm">0465 28 84 17</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@afrionebd.eu" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors" data-testid="footer-email">
                  <Mail className="w-5 h-5 text-primary" />
                  <span className="text-sm">contact@afrionebd.eu</span>
                </a>
              </li>
            </ul>
          </div>
          
          {/* Hours */}
          <div>
            <h4 className="font-semibold text-lg mb-4 uppercase tracking-widest text-xs text-white/50">Horaires</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>Lun - Ven: 9h30 - 20h</li>
              <li>Sam - Dim: 10h - 19h30</li>
            </ul>
          </div>
        </div>
        
        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col gap-4">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link to="/mentions-legales" className="text-white/60 hover:text-primary transition-colors text-sm" data-testid="footer-legal">{language === 'en' ? 'Legal notice' : 'Mentions légales'}</Link>
            <Link to="/cgv" className="text-white/60 hover:text-primary transition-colors text-sm" data-testid="footer-cgv">{language === 'en' ? 'Terms and conditions' : 'Conditions générales de vente'}</Link>
            <Link to="/confidentialite" className="text-white/60 hover:text-primary transition-colors text-sm" data-testid="footer-privacy">{language === 'en' ? 'Privacy policy' : 'Politique de confidentialité'}</Link>
            <button type="button" onClick={ouvrirReglages} className="text-white/60 hover:text-primary transition-colors text-sm text-left" data-testid="footer-cookies">{t('cookiesGerer')}</button>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} AfriOne BD. {t('rights')}.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
